// extracted by mini-css-extract-plugin
export var container = "_4e-0";
export var fallback = "_4e-5";
export var fallbackIcon = "_4e-6";
export var hidden = "_4e-2";
export var image = "_4e-3";
export var loaded = "_4e-4";
export var placeholder = "_4e-1";